import ReportsAPI from 'dashboard/api/reports';
import * as types from '../mutation-types';

export const state = {
  records: [],
  meta: {
    total_count: 0,
  },
};

export const getters = {
  getRecords: _state => _state.records,
  getMetrics: _state => _state.meta,
};

export const actions = {
  async fetch({ commit }, params) {
    try {
      const response = await ReportsAPI.getPhoneReports(params);
      commit(types.default.SET_PHONE_REPORTS, response.data);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Erro ao carregar CDRs:', error);
    }
  },

  async addRecord({ commit }, cdr) {
    try {
      const response = await window.axios.post('/api/v1/phone_cdrs', { cdr });
      commit(types.default.ADD_PHONE_RECORD, response.data.cdr_json);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Erro ao salvar CDR:', error);
    }
  },
};

export const mutations = {
  [types.default.SET_PHONE_REPORTS](_state, data) {
    _state.records = data.cdrs || [];
    _state.meta.total_count = data.pagination?.total_count || 0;
  },

  [types.default.ADD_PHONE_RECORD](_state, record) {
    _state.records = [record, ..._state.records];
    _state.meta.total_count += 1;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
